import React from 'react';
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { Navbar, Nav } from 'react-bootstrap'
import { EnvelopeFill } from 'react-bootstrap-icons'
import { useLocation } from 'react-router-dom'
import NavIconLink from '../../common/nav-icon-link'
import NavLogin from '../../common/nav-login'
import useUserDiscussions from '../../../hooks/use-user-discussions'
import Brand from './brand'

const Header = () => {
    const { hasUnread } = useUserDiscussions()
    const location = useLocation().pathname
    return (
        <React.Fragment>
            <Navbar expand='lg' bg='primary' variant='dark' fixed="top">
                <Nav className='w-100' activeKey={location} style={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'row', alignItems: 'center' }}>
                    <NavIconLink to={CLIENT_ENDPOINTS.DISCUSSIONS} icon={EnvelopeFill} badge={hasUnread}>MESSAGES</NavIconLink>
                    <Brand />
                    <NavLogin />
                </Nav>      
            </Navbar>
        </React.Fragment>
    )
}

export default Header
